<template lang="html">
  <div>
    <div class="header_top">
      <van-nav-bar
        title="论坛版块"
        left-arrow
        fixed
        @click-left="onClickLeft"/>
    </div>
    <div class="block_content">
      <ItemTitle title="玩转社区" :isShowBtn="true"/>
      <ul class="nav_list">
        <router-link tag="li" to="/block" class="border_top"><i>&#xe624;</i><span>论坛版块</span></router-link>
        <router-link tag="li" to="/integral" class="border_top border_right"><i>&#xe6f2;</i><span>积分商城</span></router-link>
        <router-link tag="li" to="/photo" ><i>&#xe609;</i><span>产品图集</span></router-link>
        <router-link tag="li" to="/blocklist/57" class="border_right"><i>&#xe630;</i><span>坚果动态</span></router-link>
        <li  @click="sign_in"><i>&#xe615;</i><span>游戏互动</span></li>
        <router-link tag="li" to="/blocklist/47" class="border_right"><i>&#xe606;</i><span>坚果活动</span></router-link>
      </ul>
      <div v-for="(item, index) in blockData" :key="index">
        <ItemTitle :title="item.name" :isShowBtn="false"/>
        <ul class="block_list">
          <router-link tag="li" v-for="(i, val) in item.forumslist" :key="val" :to="`/blocklist/${i.fid}`">
            <div class="img_box">
              <img :src="i.iconimg" alt="">
            </div>
            <div class="block_item_right">
              <h2>{{i.name}}</h2>
              <p class="ellipsis">{{i.lastpost.subject}}</p>
              <span>主题：{{i.threads}}</span><em>贴数：{{i.posts}}</em>
            </div>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ItemTitle from '@/components/ItemTitle/ItemTitle'
import utilAxios from '@/utils/axios'
import { NavBar } from 'vant'
import { Toast } from 'vant'
Vue.use(Toast)
Vue.use(NavBar)
export default {
  components: {
    ItemTitle
  },
  data (){
    return{
      blockData: [],
      uid:0,
      mobile:'',
    }
  },
  beforeCreate() {
    Toast.loading({
      mask: false,
      message: '加载中...'
    })
  },
  created() {
    this.uid = this.getCookie('ECS[user_id]')
    this.mobile=this.getCookie('ECS[mobile]')
    this.getBlockData()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    trim(str) {
      return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '')
    },
    getCookie(name) {
      let result;
      let cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        let cookie = this.trim(cookies[i])
        if (cookie.substring(0, name.length + 1) == (name + '=')) {
          result = decodeURIComponent(cookie.substring(name.length + 1))
        }
      }
      return result
    },
    sign_in(){
      if(this.uid=='0'){
         window.location.href="https://www.jmgo.com/mobile/user.php?act=bbslogin&sync=bbs&loginhash=&back_act="+escape('http://bbs.jmgo.com/dist/#/sign')
      }
      /*else if(!this.mobile){
        location.href = 'https://www.jmgo.com/mobile/user.php?act=m_bind&back_act='+escape('http://bbs.jmgo.com/dist/#/sign');
      }*/
      else{
        this.$router.push('/sign')
        

      }
      
      console.log(this.show)
    },
    getBlockData() {
      utilAxios.get({
        url: '/new_api.php?module=forum&mod=index',
        method: 'GET',
        callback: (res) => {
          console.log(res.data.catlist)
          if (res.data.code == 100) {
            this.blockData = res.data.catlist
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.nav_list {
    padding: 0.1rem;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid rgba(234,234,234,.3);
    background: #fff;
    li {
        width: 50%;
        height: 0.44rem;
        line-height: 0.44rem;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(234,234,234,.3);
        border-left: 1px solid rgba(234,234,234,.3);
        i {
            font-size: 0.26rem;
            padding: 0 0.15rem;
            vertical-align: bottom;
            color: rgb(83, 169, 254);
            line-height: 0.44rem;
        }
        span {
            font-size: 0.13rem;
            vertical-align: bottom;
        }
    }
    li.border_top {
        border-top: 1px solid rgba(234,234,234,0.3);
    }
    li.border_right {
        border-right: 1px solid rgba(234,234,234,0.3);
    }
}
.block_list{
  padding: 0 .1rem;
  background: #fff;
  border-top: 1px solid #EEE;
  margin-bottom: .1rem;
  li{
    width: 100%;
    height: 1rem;
    border-bottom: 1px solid #EEE;
    display: flex;
    .img_box{
      width: 1rem;
      height: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: .7rem;
        height: .7rem;
        border-radius: 100%;
      }
    }
    .block_item_right{
      flex: 1;
      height: 100%;
      padding: 0 0 0 .1rem;
      h2{
        font-size: .16rem;
        line-height: .3rem;
        margin-top: .14rem;
      }
      p{
        font-size: .12rem;
        line-height: .24rem;
        width: 2.2rem;
      }
      span{
        font-size: .12rem;
        padding-right: .1rem;
      }
      em{
        font-size: .12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Block/Block.vue